import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

interface IGpsTrackerSelect {
  id: number;
  fullName: string;
}

export const gpsTrackerSelectKey = () => ['gpsTrackerSelect'];
export const gpsTrackerSelectFn = () => apiClient.get(`${APP_API_URL_V2}fsd/gps-tracker/select`);

export const useGPSTrackerSelectQuery = () => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: gpsTrackerSelectKey(),
    queryFn: gpsTrackerSelectFn,
    useErrorBoundary: true,
    select: ({ data }: AxiosResponse<{ data: Array<IGpsTrackerSelect> }>) => data?.data || [],
    placeholderData: {
      data: {
        data: [],
      },
    },
  });
};
